import React from 'react'
import PropTypes from 'prop-types'
import ModalHeader from 'components/ModalHeader'
import { StyledModal, StyledModalFooter } from './component.styles'
import AddImplementationApproach from './AddImplementationApproach'

const ImplementationApproachModal = ({
  errors,
  flowLabel,
  handleCancel,
  handleChange,
  handleClose,
  handleNextButtonClick,
  hasApiError,
  isSubmitting,
  modals,
  touched,
  values,
}) => {
  const currentModal = modals?.[0] || {}
  const { helpCopy, nextLabel } = currentModal
  return (
    <StyledModal
      dataTestId="implementation-approach-modal"
      isModalOpen
      modalClose={handleClose}
    >
      <ModalHeader
        flowLabel={flowLabel}
        handleCancel={handleCancel}
        handleClose={handleClose}
        showBackButton={false}
      />
      <AddImplementationApproach
        errors={errors}
        handleChange={handleChange}
        modalData={currentModal}
        touched={touched}
        values={values}
      />
      <StyledModalFooter
        handleNextButtonClick={handleNextButtonClick}
        hasApiError={hasApiError}
        helpCopy={helpCopy}
        isSubmitting={isSubmitting}
        isValid={true}
        modalName="implementation-approach"
        nextButtonText={nextLabel}
        showCancelButton={false}
      />
    </StyledModal>
  )
}

ImplementationApproachModal.propTypes = {
  errors: PropTypes.object.isRequired,
  flowLabel: PropTypes.string.isRequired,
  handleCancel: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleNextButtonClick: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  hasApiError: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  modals: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  touched: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
}

export default ImplementationApproachModal
